import { connect, useDispatch } from "react-redux";
import {
  BackButton,
  Button,
  ErrorMark,
  LoadingIndicator,
  NavigationLinkButton
} from "../../../components/RegularComponents";
import { btlReviewLicenceWithdrawSelect } from "../../../redux/selector/bltReviewSelector";
import { useEffect, useState } from "react";
import { fetchSearchResponse } from "../../../redux/slice/bltHomeSlice";
import {
  APPLICATION_STATUS_APPROVED_ISSUED,
  APPLICATION_STATUS_WITHDRAWN_APPROVED,
  LICENCE_STATUS_ACTIVE,
  LICENCE_STATUS_SUSPENDED,
  LICENCE_STATUS_WITHDRAWN,
  LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION,
  LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION,
  LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION,
  LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION,
  LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION,
  LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION,
  LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION,
  LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION
} from "../../../app/constants";
import { titleStringFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
import { humanReadableDate } from "../../../app/utils";

const LicenceWithdrawalConfirmation = (props) => {
  const dispatch = useDispatch();
  const { primaryAgencyApplication, currentAgentApplication } = props;
  const [existingBrokerApplication, setExistingBrokerApplication] = useState(null);
  const [openCorrectLicenceInput, setOpenCorrectLicenceInput] = useState(false);
  const [noActiveLicenceFoundError, setNoActiveLicenceFoundError] = useState();
  const [loadingIndicator, setLoadingIndicator] = useState(false);
  const [licenceTypeMismatch, setLicenceTypeMismatch] = useState("");
  const [pbLicenceTranferWarning, setPBLicenceTranferWarning] = useState("");

  const existingLicenceNumber =
    currentAgentApplication?.businessLicenceData?.brokerLicenceNumber ??
    primaryAgencyApplication?.businessLicenceData?.mraNSLicenceNumber;

  const adjudicatingApplication = currentAgentApplication || primaryAgencyApplication;

  const adjudicatingAppLicenceSubType = titleStringFromLicenceSubType(
    adjudicatingApplication?.licencingSubType
  );

  // Fetch initial licence details from currentAgentApplication NS brokerLicenceNumber
  useEffect(() => {
    if (existingBrokerApplication || !existingLicenceNumber) {
      return;
    }

    setLoadingIndicator(true);

    const searchParams = {
      licenceTypeText: existingLicenceNumber,
      page: 1,
      numberOfRecords: 10,
      licenceTypeOption: null
    };

    dispatch(fetchSearchResponse(searchParams))
      .then((results) => {
        const licenceList = results?.businessLicenceList;
        if (licenceList?.length) {
          const application = licenceList.find(
            (a) =>
              (a.licenceNumber === existingLicenceNumber &&
                a.licenceStatus === LICENCE_STATUS_ACTIVE &&
                a.applicationStatus === APPLICATION_STATUS_APPROVED_ISSUED) ||
              a.licenceStatus === LICENCE_STATUS_SUSPENDED
          );

          if (application) {
            setExistingBrokerApplication(application);
            if (
              checkSuitableTargetLicence(
                currentAgentApplication,
                primaryAgencyApplication,
                application
              )
            ) {
              setLicenceTypeMismatch(application.licencingSubType);
            }

            if (
              application.licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION
            ) {
              setPBLicenceTranferWarning(application.licencingSubType);
            }
          } else {
            setNoActiveLicenceFoundError(true);
          }
        } else {
          setNoActiveLicenceFoundError(true);
        }
      })
      .finally(() => {
        setLoadingIndicator(false);
      });
  }, [
    existingLicenceNumber,
    existingBrokerApplication,
    currentAgentApplication,
    primaryAgencyApplication,
    dispatch
  ]);

  const proceedLicenceCancel = (application) => {
    if (!application) {
      console.log("No application");
      return;
    }

    const oldApplication = {
      ...application,
      applicationStatus: APPLICATION_STATUS_WITHDRAWN_APPROVED,
      licenceStatus: LICENCE_STATUS_WITHDRAWN,
      changeType: "SAVE"
    };

    props.proceedLicenceTransfer(oldApplication);
  };

  const onCancel = () => {
    //On cancel, go back to queue without making any change.
    props.onCancel();
  };

  const handleYes = () => {
    //On Yes,need proceed for transfer of licence number
    proceedLicenceCancel(existingBrokerApplication);
  };

  const handleChangeLicenceNumber = () => {
    //On No, proceed to accept correct licence number
    setOpenCorrectLicenceInput(true);
  };

  const onBackClick = () => {
    if (props.onBack) {
      props.onBack();
    }
  };

  const onLicenceInputBack = () => {
    setOpenCorrectLicenceInput(false);
  };

  const onLicenceSearchFromInput = (application) => {
    setExistingBrokerApplication(application);

    // if(currentAgentApplication) {
    //   if (
    //     (currentAgentApplication.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION ||
    //       currentAgentApplication.licencingSubType ===
    //         LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION) &&
    //     application.licencingSubType !== currentAgentApplication?.licencingSubType
    //   ) {
    //     console.log("currentAgentApplication",currentAgentApplication);
    //     setLicenceTypeMismatch(application.licencingSubType);
    //   } else if (licenceTypeMismatch) {
    //     setLicenceTypeMismatch("");
    //   }
    // }

    if (
      checkSuitableTargetLicence(currentAgentApplication, primaryAgencyApplication, application)
    ) {
      setLicenceTypeMismatch(application.licencingSubType);
    } else if (licenceTypeMismatch) {
      setLicenceTypeMismatch("");
    }

    if (
      application.licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION ||
      application.licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION
    ) {
      setPBLicenceTranferWarning(application.licencingSubType);
    } else if (pbLicenceTranferWarning) {
      setPBLicenceTranferWarning("");
    }

    //Reset Error
    if (noActiveLicenceFoundError) {
      setNoActiveLicenceFoundError(false);
    }
  };

  if (openCorrectLicenceInput) {
    return (
      <CorrectLicenceNumberView
        onLicenceInputBack={onLicenceInputBack}
        onLicenceSearchFromInput={onLicenceSearchFromInput}
        onContinueApproval={props.bltReviewHandleContinue}
        onChangeDecision={onBackClick}
        onCancel={onCancel}
      />
    );
  }

  //When licenceNumber is available in businessLicenceData of the broker (brokerLicenceNumber).
  let enteredText = " ";
  if (
    existingBrokerApplication &&
    existingLicenceNumber !== existingBrokerApplication?.licenceNumber
  ) {
    //When application is searched from the input licence number.
    enteredText = ", that you entered, ";
  }

  let licenceSubTypeText = "";
  let expiryDate = "";

  if (existingBrokerApplication) {
    licenceSubTypeText = getOldLicenceTypeText(existingBrokerApplication.licencingSubType);
    expiryDate = humanReadableDate(existingBrokerApplication.endDate);
  }

  const oldUserRole = getLicencedUserRoleFromLicenceSubType(
    existingBrokerApplication?.licencingSubType
  );

  return (
    <div className="container">
      <div className="row topMarginNormal">
        <div className="col-3">
          <BackButton title="Back" onClick={onBackClick} />
        </div>
      </div>
      <div className="row bottomMarginMedium">
        <div className="col-lg-12">
          {noActiveLicenceFoundError ? (
            <h2>{"New " + adjudicatingAppLicenceSubType}</h2>
          ) : (
            <h2>{"Existing Licence"}</h2>
          )}
        </div>
      </div>
      <LoadingIndicator isLoading={loadingIndicator} />

      {existingBrokerApplication && (
        <div>
          The <b>{licenceSubTypeText}</b> application with Nova Scotia Licence Number{" "}
          <b>{existingBrokerApplication.licenceNumber}</b> (Expiry Date: <b>{expiryDate}</b>){" "}
          {enteredText}was found to be associated with{" "}
          <b>{existingBrokerApplication.contactName}</b>, who is a {oldUserRole} for{" "}
          <b>{existingBrokerApplication.name}</b>.
        </div>
      )}

      {noActiveLicenceFoundError && (
        <>
          <h4>{"No Active Licence Found"}</h4>
          <div>
            <div className="ns-error-message field-validation-error" style={{ marginTop: 30 }}>
              {ErrorMark()} No active Mortgage Broker Licence found with the licence number{" "}
              <b>{existingLicenceNumber}</b>.
            </div>
            {/*Note : The applicant paid a transfer fee (half of the regular fee). If the applicant is
            not transferring an active licence, they will need to apply for a new licence. This
            application will need to be cancelled and they will need to be refunded.*/}
            The applicant submitted an invalid NS Licence number and was charged a transfer fee
            (half of regular amount). To charge the correct amount you will need to:
            <ul>
              <li>Change the decision to Cancelled.</li>
              <li>Provide a refund for the transfer fee.</li>
              <li>Have the client submit a new application with no NS Licence number.</li>
            </ul>
          </div>
        </>
      )}

      {pbLicenceTranferWarning ? (
        <div className="ns-error-message field-validation-error" style={{ marginTop: 30 }}>
          {ErrorMark()} Transferring the Principal Broker, will leave the{" "}
          <b>{existingBrokerApplication.name}</b> with no Principal Broker.
        </div>
      ) : null}

      {licenceTypeMismatch ? (
        <div style={{ marginTop: 30 }}>
          <b>Note : </b> Applicant's new licence type{" "}
          <b>{titleStringFromLicenceSubType(currentAgentApplication?.licencingSubType)}</b> does not
          match with previous licence type.
          {/* <b>{titleStringFromLicenceSubType(existingBrokerApplication.licencingSubType)}.</b> */}
        </div>
      ) : null}

      <div style={{ marginTop: "30px" }}>- Is this licence number correct?</div>
      {/*existingBrokerApplication && !pbLicenceTranferWarning ? (
        <div>- Did you receive confirmation from their current Principal Broker?</div>
      ) : null*/}

      {/* Yes/No Answer */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
        {noActiveLicenceFoundError ? (
          <>
            <div style={{ marginRight: "30px" }}>
              <Button
                showSpinner={false}
                className={"btn btn-primary btn-lg"}
                buttonType={"regular_primary"}
                text={"Continue with approval"}
                onClick={props.bltReviewHandleContinue}
              />
            </div>
            <div style={{ marginRight: "30px" }}>
              <Button
                showSpinner={false}
                className={"btn btn-primary btn-lg"}
                buttonType={"regular_primary"}
                text={"Change decision"}
                onClick={onBackClick}
              />
            </div>
          </>
        ) : (
          <div style={{ marginRight: "30px" }}>
            <Button
              showSpinner={false}
              className={"btn btn-primary btn-lg"}
              buttonType={"regular_primary"}
              text={"Yes, make the change"}
              onClick={handleYes}
            />
          </div>
        )}

        <div style={{ marginRight: "30px" }}>
          <Button
            className={"btn btn-primary btn-lg" /*btn btn-primary ns-btn-yes-no*/}
            buttonType={"regular_primary"}
            text={"Change the Licence Number"}
            onClick={handleChangeLicenceNumber}
          />
        </div>
        <div style={{ marginRight: "30px" }}>
          <NavigationLinkButton
            id="licence-withdraw-cancel-button"
            text="Cancel and return to BL Admin"
            onClick={onCancel}
          />
        </div>
      </div>
    </div>
  );
};

const CorrectLicenceNumberView = (props) => {
  const dispatch = useDispatch();

  const [licenceNumber, setLicenceNumber] = useState("");
  const [noLicenceFoundError, setNoLicenceFoundError] = useState(false);
  const [continueSpinner, setContinueSpinner] = useState(false);

  const onBackClick = () => {
    if (props.onLicenceInputBack) {
      props.onLicenceInputBack();
    }
  };

  const handleSearch = () => {
    if (!licenceNumber?.trim()?.length) {
      return;
    }

    const searchParams = {
      licenceTypeText: licenceNumber,
      page: 1,
      numberOfRecords: 10,
      licenceTypeOption: null
    };

    setContinueSpinner(true);
    dispatch(fetchSearchResponse(searchParams))
      .then((results) => {
        const licenceList = results?.businessLicenceList;
        if (licenceList?.length) {
          const application = licenceList.find(
            (a) =>
              (a.licenceNumber === licenceNumber &&
                a.licenceStatus === LICENCE_STATUS_ACTIVE &&
                a.applicationStatus === APPLICATION_STATUS_APPROVED_ISSUED) ||
              a.licenceStatus === LICENCE_STATUS_SUSPENDED
          );
          if (application) {
            props.onLicenceSearchFromInput(application);
            props.onLicenceInputBack();
          } else {
            setNoLicenceFoundError(true);
          }
        } else {
          setNoLicenceFoundError(true);
        }
      })
      .finally(() => {
        setContinueSpinner(false);
      });
  };

  return (
    <div className="container">
      <div className="row topMarginNormal">
        <div className="col-3">
          <BackButton title="Back" onClick={onBackClick} />
        </div>
      </div>
      <div className="row bottomMarginMedium">
        <div className="col-lg-12">
          <h2>Enter the correct licence number of this mortgage broker</h2>
        </div>
      </div>
      <fieldset className="ns-fieldset">
        <label
          id={"mortgage-broker-licence-number-label"}
          className="ns-label"
          autoComplete="licence-number"
          htmlFor={"mortgage-broker-licence-number-text"}
        >
          Licence number
        </label>
        <input
          style={{ marginRight: 10 }}
          type="text"
          className={"fw-25" + (noLicenceFoundError ? " ns-input--error" : " ns-input")}
          id={"mortgage-broker-licence-number-text"}
          name={"mortgage-broker-licence-number-text"}
          value={licenceNumber}
          onChange={(e) => {
            setLicenceNumber(e.target.value);
            if (noLicenceFoundError) {
              setNoLicenceFoundError(false);
            }
          }}
        />
        <Button
          showSpinner={continueSpinner}
          id="search-licence-application-data"
          buttonType="regular_primary"
          text={"Search Application"}
          onClick={handleSearch}
        />

        {noLicenceFoundError && (
          <span className="ns-error-message field-validation-error">
            {ErrorMark()}
            {" No active application found with the provided licence number."}
          </span>
        )}
      </fieldset>

      <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
        <div style={{ marginRight: "30px" }}>
          <Button
            showSpinner={false}
            className={"btn btn-primary btn-lg"}
            buttonType={"regular_primary"}
            text={"Continue with approval"}
            onClick={props.onContinueApproval}
          />
        </div>
        <div style={{ marginRight: "30px" }}>
          <Button
            showSpinner={false}
            className={"btn btn-primary btn-lg"}
            buttonType={"regular_primary"}
            text={"Change decision"}
            onClick={props.onChangeDecision}
          />
        </div>
        <div style={{ marginRight: "30px" }}>
          <NavigationLinkButton
            id="licence-withdraw-cancel-button"
            text="Cancel and return to BL Admin"
            onClick={props.onCancel}
          />
        </div>
      </div>
    </div>
  );
};

function getLicencedUserRoleFromLicenceSubType(licencingSubType) {
  if (
    licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION ||
    licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION
  ) {
    return "Principal Broker";
  } else if (
    licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION ||
    licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION
  ) {
    return "Mortgage Broker";
  } else if (
    licencingSubType === LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION ||
    licencingSubType === LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION
  ) {
    return "Associate Mortgage Broker";
  }

  return titleStringFromLicenceSubType(licencingSubType);
}

function getOldLicenceTypeText(licencingSubType) {
  if (licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION) {
    return "Mortgage Broker Licence";
  }
  return titleStringFromLicenceSubType(licencingSubType);
}

function checkSuitableTargetLicence(
  currentAgentApplication,
  primaryAgencyApplication,
  searchedApplication
) {
  if (
    currentAgentApplication?.licencingSubType ===
      LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION ||
    currentAgentApplication?.licencingSubType ===
      LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION
  ) {
    if (
      !(
        searchedApplication.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION ||
        searchedApplication.licencingSubType ===
          LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION ||
        searchedApplication.licencingSubType ===
          LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION ||
        searchedApplication.licencingSubType ===
          LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION
      )
    ) {
      return false;
    }
  }

  if (
    currentAgentApplication?.licencingSubType ===
      LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION ||
    currentAgentApplication?.licencingSubType ===
      LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION
  ) {
    if (
      !(
        searchedApplication.licencingSubType ===
          LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION ||
        searchedApplication.licencingSubType ===
          LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION
      )
    ) {
      return false;
    }
  }

  if (primaryAgencyApplication) {
    if (
      primaryAgencyApplication.licencingSubType ===
        LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION ||
      primaryAgencyApplication.licencingSubType ===
        LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION
    ) {
      if (
        !(
          searchedApplication.licencingSubType ===
            LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION ||
          searchedApplication.licencingSubType ===
            LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION ||
          searchedApplication.licencingSubType ===
            LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION ||
          searchedApplication.licencingSubType ===
            LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION
        )
      ) {
        return false;
      }
    }

    if (
      primaryAgencyApplication.licencingSubType ===
        LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION ||
      primaryAgencyApplication.licencingSubType ===
        LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION
    ) {
      if (
        !(
          searchedApplication.licencingSubType ===
            LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION ||
          searchedApplication.licencingSubType ===
            LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION ||
          searchedApplication.licencingSubType ===
            LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION ||
          searchedApplication.licencingSubType ===
            LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION
        )
      ) {
        return false;
      }
    }
  }

  return true;
}

export default connect(btlReviewLicenceWithdrawSelect)(LicenceWithdrawalConfirmation);
